import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ActivitiesSlider } from './components/ActivitiesSlider';
import { CategoriesSection } from './components/CategoriesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { Footer } from './components/Footer';
import { SEO } from '../../components/SEO/SEO';

export const Home = () => {
  return (
    <>
      <SEO 
        title="Hobi Hub | Go Beyond Routine, Find Your Flow - Events & Experiences"
        description="Discover unique events and experiences that energize your day and elevate your lifestyle. Book workshops, activities, and adventures in your city with Hobi Hub."
        keywords="Hobi Hub, events, experiences, workshops, activities, hobbies, adventures, lifestyle, booking platform, things to do, Mumbai events"
        canonicalUrl="https://hobi.co.in/"
      />
      <section className='hero-bg'>
        <Navbar />
        
        <Hero />
      </section>
     
      <ActivitiesSlider/>
      <CategoriesSection/>
      <TestimonialsSection/>
      <Footer />
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css"
      />
    </>
  );
};
